import { Injectable, Input } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { InfillTypes } from '../../../../services/railing/infills/model/infill-types';
import {Observable} from 'rxjs/Observable';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class GetQuoteResourceService {
  private _apiUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getDealers(data) {
    console.log('data', data);
    return this.http.post(`${this._apiUrl}/get-dealers`, data).pipe(
      catchError(err => {
        return ErrorObservable.create('Error getting dealers');
      })
    );
  }

  chooseDealer(data) {
    console.log('chooseDealer', data);
    return this.http.post(`${this._apiUrl}/choose-dealer`, data).pipe(
      catchError(err => {
        return ErrorObservable.create('Error choosing dealer');
      })
    );
  }

  getSettings() {
    return this.http.get(`${this._apiUrl}/settings`).pipe(
      catchError(err => {
        return ErrorObservable.create('Error fetching settings');
      })
    );
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/services/get-quote-resource.service.ts